import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type FlowStepsProps = {
  steps: string[];
  align?: 'center' | 'start';
  className?: string;
};
export function FlowSteps({
  steps,
  align = 'center',
  className = ''
}: FlowStepsProps) {
  return <ol className={`flex flex-wrap items-center gap-x-2 gap-y-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-cyan-400 md:text-base ${align === 'center' ? 'justify-center' : 'justify-start'} ${className}`} data-id="element-30" data-mp="270e5e2xnkoll">
      {steps.map((step, i) => <li key={step} className="flex items-center gap-2" data-id="element-31" data-mp="34ml9zctyigxy" data-mpi={i}>
          {step}
          {i < steps.length - 1 && <ArrowRightIcon className="h-4 w-4 text-cyan-600" aria-hidden="true" data-id="element-32" data-mp="2py78b58a0yiz" />}
        </li>)}
    </ol>;
}